import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ApiService from '../../services/ApiService'
import { DATA_ALREADY_EXIST } from '../../utility/ResponseConstant'
import { showAlert } from '../../utility/SweetAlert'

const InteractorFundBankFormAction = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { account } = useSelector((state) => state.account)
  const { seller } = useSelector((state) => state.seller)

  const addBank = useCallback(
    (payload = {}, loadingCallback = () => {}) => {
      const payloadRequest = {
        ...payload,
        account_uid: account.uid,
        company_uid: seller.company_uid,
        created_by: account.full_name,
      }
      loadingCallback(true)
      ApiService.jsonRequest('/fund-account/bank-create', payloadRequest, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_added`),
            timer: 2000,
          })
          navigate('/fund/bank')
        } else {
          if (response.messages === DATA_ALREADY_EXIST) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 2000,
            })
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 2000,
            })
          }
        }
      })
    },
    [account.full_name, account.uid, navigate, seller.company_uid, t],
  )

  const deleteBank = useCallback(
    (payload = {}, callback = () => {}, loadingCallback = () => {}) => {
      let requestPayload = { ...payload, updated_by: account.full_name }
      loadingCallback(true)
      ApiService.jsonRequest('/fund-account/bank-delete', requestPayload, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_deleted`),
            timer: false,
          })
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
        callback()
      })
    },
    [account.full_name, t],
  )

  const updateBank = useCallback(
    (payload = {}, loadingCallback = () => {}) => {
      let productPayload = {
        ...payload,
        account_uid: account.uid,
        company_uid: seller.company_uid,
        updated_by: account.full_name,
      }
      loadingCallback(true)
      ApiService.jsonRequest('/fund-account/bank-update', productPayload, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_updated`),
            timer: 2000,
          })
          navigate('/fund/bank')
        } else {
          if (response.messages === DATA_ALREADY_EXIST) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 2000,
            })
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 2000,
            })
          }
        }
      })
    },
    [account.full_name, account.uid, navigate, seller.company_uid, t],
  )

  return {
    addBank,
    deleteBank,
    updateBank,
  }
}

export default InteractorFundBankFormAction
